const TechmaniacsAbout = () => {
    return(
        <div className="TechAbout">
            <h2 className="about-text">
                About
            </h2>
            <div className="sep1"></div>
            <div className="TechAbout1">
                <p>
                    Welcome to the Techmaniacs Club, your ultimate destination for all things related to Robotics, Drones, Electronics, IoT, SBCs and Microcontrollers! We are a passionate community of tech enthusiasts, engineers, and innovators, dedicated to exploring the frontiers of technology and pushing the boundaries of what is possible. Since our inception, we have focused to give students a platform to develop their skills to not only be industry-ready but solve society’s problems using technology. 
                </p>
                <p>
                    Our club is a hub for individuals who share a common interest in cutting-edge technologies. Whether you are a beginner looking to dive into the exciting world of robotics or an experienced professional seeking to expand your knowledge, you have a place in our club.
                </p>
                <p>
                    Whether you're a hobbyist, veteran, or a beginner eager to explore the possibilities of technology, our club provides a supportive and engaging environment where you can learn, collaborate, and push the boundaries of technical innovation!
                </p>
            </div>
            <h2 className="about-text">
                Our Mission
            </h2>
            <div className="sep1"></div>
            <div className="TechAbout1">
                <p>
                    The mission of Techmaniacs Club is to provide students with the opportunity to learn about technology, explore their interests, and build projects. We believe that technology can be used to solve problems, make the world a better place, and empower people. We are committed to providing students with the resources and support they need to succeed in the tech industry.
                </p>
                <p>
                    India is known for its service providing sectors and not for technical innovation and manufacturing in modern world especially when it comes to complex electronic hardware, semiconductors, drones or robotics. These technologies have capability to solve  India’s many socio-economic problems if they are targeted for Indian society. We as a club aim to light a fire in hearts of the brightest minds in India at IIT Tirupati towards such innovations by providing them resources and guidance required.
                </p>
            </div>
        </div>
    )
}

export default TechmaniacsAbout